import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { errorPrefix } from "./Constants";
import { isNumber } from "../../Utils/Utils";
export var Vector3d = /*#__PURE__*/function () {
  function Vector3d(xOrCoords, y, z) {
    var _this = this;

    _classCallCheck(this, Vector3d);

    this._updateFromAngle = function (angle, length) {
      _this.x = Math.cos(angle) * length;
      _this.y = Math.sin(angle) * length;
    };

    if (!isNumber(xOrCoords) && xOrCoords) {
      this.x = xOrCoords.x;
      this.y = xOrCoords.y;
      var coords3d = xOrCoords;
      this.z = coords3d.z ? coords3d.z : 0;
    } else if (xOrCoords !== undefined && y !== undefined) {
      this.x = xOrCoords;
      this.y = y;
      this.z = z !== null && z !== void 0 ? z : 0;
    } else {
      throw new Error("".concat(errorPrefix, " Vector3d not initialized correctly"));
    }
  }

  _createClass(Vector3d, [{
    key: "angle",
    get: function get() {
      return Math.atan2(this.y, this.x);
    },
    set: function set(angle) {
      this._updateFromAngle(angle, this.length);
    }
  }, {
    key: "length",
    get: function get() {
      return Math.sqrt(this.getLengthSq());
    },
    set: function set(length) {
      this._updateFromAngle(this.angle, length);
    }
  }, {
    key: "add",
    value: function add(v) {
      return Vector3d.create(this.x + v.x, this.y + v.y, this.z + v.z);
    }
  }, {
    key: "addTo",
    value: function addTo(v) {
      this.x += v.x;
      this.y += v.y;
      this.z += v.z;
    }
  }, {
    key: "copy",
    value: function copy() {
      return Vector3d.clone(this);
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return this.sub(v).length;
    }
  }, {
    key: "distanceToSq",
    value: function distanceToSq(v) {
      return this.sub(v).getLengthSq();
    }
  }, {
    key: "div",
    value: function div(n) {
      return Vector3d.create(this.x / n, this.y / n, this.z / n);
    }
  }, {
    key: "divTo",
    value: function divTo(n) {
      this.x /= n;
      this.y /= n;
      this.z /= n;
    }
  }, {
    key: "getLengthSq",
    value: function getLengthSq() {
      return Math.pow(this.x, 2) + Math.pow(this.y, 2);
    }
  }, {
    key: "mult",
    value: function mult(n) {
      return Vector3d.create(this.x * n, this.y * n, this.z * n);
    }
  }, {
    key: "multTo",
    value: function multTo(n) {
      this.x *= n;
      this.y *= n;
      this.z *= n;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var length = this.length;

      if (length != 0) {
        this.multTo(1.0 / length);
      }
    }
  }, {
    key: "rotate",
    value: function rotate(angle) {
      return Vector3d.create(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle), 0);
    }
  }, {
    key: "setTo",
    value: function setTo(c) {
      this.x = c.x;
      this.y = c.y;
      var v3d = c;
      this.z = v3d.z ? v3d.z : 0;
    }
  }, {
    key: "sub",
    value: function sub(v) {
      return Vector3d.create(this.x - v.x, this.y - v.y, this.z - v.z);
    }
  }, {
    key: "subFrom",
    value: function subFrom(v) {
      this.x -= v.x;
      this.y -= v.y;
      this.z -= v.z;
    }
  }], [{
    key: "origin",
    get: function get() {
      return Vector3d.create(0, 0, 0);
    }
  }, {
    key: "clone",
    value: function clone(source) {
      return Vector3d.create(source.x, source.y, source.z);
    }
  }, {
    key: "create",
    value: function create(x, y, z) {
      return new Vector3d(x, y, z);
    }
  }]);

  return Vector3d;
}();